// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"2ce25360","710":"779d29ab","983":"1806c5fe"}[chunkId] + ".chunk.js";
};